<template>
  <div id="app" class="row vert-offset-top-1">
    <div class="row justify-content-center">
      <div class="col s12 m10 l8 offset-m1 offset-l2">
        <h4 class="grey-text text-darken-3">
          Bookings
        </h4>
        <div id="card" class="card col s12 vert-offset-top-1  z-depth-3 ">
          <div
            class="card-title center padding-top-half padding-bottom-half border-bottom-1 grey-border border-lighten-2"
          >
            <h6 class="font-bold ">Check Patient</h6>
            <div class="row vert-offset-top-half vert-offset-bottom-half">
              <div class="col s12 vert-offset-top-1">
                <InputComponent
                  placeholder="Enter number"
                  type="text"
                  v-model="mobile"
                ></InputComponent>
                <button
                  type="submit"
                  @click="CheckPatient"
                  class="btn btn-small  deep-orange darken-2 white-text col s3 offset-s9 "
                >
                  Find
                </button>
              </div>

              <div class="col s4 padding-bottom-1 padding-top-1">
                <button
                  type="submit"
                  @click="goback"
                  class="btn btn-small deep-orange darken-2 white-text col s12 "
                >
                  back
                </button>
              </div>
              <div class="col s4 offset-s4 padding-bottom-1 padding-top-1 ">
                <button
                  type="submit"
                  @click="goto"
                  class="btn btn-small deep-orange darken-2 white-text col s12"
                >
                  Continue
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import http from "@/http-common";
import InputComponent from "@/components/materiallize/InputComponent";
export default {
  name: "CheckPatient",
  components: {
    InputComponent
  },
  data() {
    return {
      mobile: [],
      countries: "BW"
    };
  },
  methods: {
    goto() {
      this.$store.dispatch("START_PROCESSING");
      this.$store.dispatch("SET_DATE", this.date);
      this.$store.dispatch("STOP_PROCESSING");
      this.$router.push("/reason");
    },
    goback() {
      this.$router.push("/");
    },
    CheckPatient() {
      this.$store.dispatch("START_PROCESSING");
      return new Promise(resolve => {
        http({
          url: "/api/patient/check",
          data: {
            country: this.countries,
            mobile: this.mobile
          },
          method: "POST",
          timeout: 30000
        })
          .then(response => {
            this.$store.dispatch("STOP_PROCESSING");
            this.mobile = response.data.data;
            resolve(response);
          })
          .catch(response => {
            this.$store.dispatch("STOP_PROCESSING");
            this.$store.dispatch("GET_MESSAGES", response.data.message);
            resolve(response);
          });
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-kerning: normal;
}
</style>
